import { render, staticRenderFns } from "./VehicleFlagIcon.vue?vue&type=template&id=3412d60c&scoped=true"
import script from "./VehicleFlagIcon.vue?vue&type=script&lang=js"
export * from "./VehicleFlagIcon.vue?vue&type=script&lang=js"
import style0 from "./VehicleFlagIcon.vue?vue&type=style&index=0&id=3412d60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412d60c",
  null
  
)

export default component.exports